import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { LookInside } from './components/LookInside';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { MobileBuyBar } from './components/MobileBuyBar';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-cream text-ink font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="3mlatmwc87vop">
      <MetaPixel data-id="element-1" data-mp="3rbzlwdvqcwow" />
      <main data-id="element-2" data-mp="3rdkie91luppe">
        <Hero data-id="element-3" data-mp="3rcsulke91w9o" />
        <SocialProofBar data-id="element-4" data-mp="3recdlirailf5" />
        <PainGrid data-id="element-5" data-mp="5otf64sd496" />
        <ProductReveal data-id="element-6" data-mp="67yvnd9206b" />
        <LookInside data-id="element-7" data-mp="4n7u7q58zd7" />
        <Tomes data-id="element-8" data-mp="82kz509bybz" />
        <Bonuses data-id="element-9" data-mp="2zl39tfhhuw2o" />
        <ValueStack data-id="element-10" data-mp="2zllf11m4wkmq" />
        <Urgency data-id="element-11" data-mp="2zm4zaoz9bl3x" />
        <Pricing data-id="element-12" data-mp="2zmo4d53t6f0j" />
        <Testimonials testimonials={shortTestimonials} background="white" data-id="element-13" data-mp="2zn6b4vo3kbmp" />
        <Guarantee data-id="element-14" data-mp="33n6zp94wu37h" />
        <Faq data-id="element-15" data-mp="33oriy2lrxzq1" />
        <Testimonials testimonials={moreTestimonials} title="More groups, more weeks" background="blush" data-id="element-16" data-mp="33ohzyyz5cstu" />
        <CostOfInaction data-id="element-17" data-mp="3dlw5i3jj7x7d" />
        <Close data-id="element-18" data-mp="3dm5z013scmht" />
      </main>
      <div className="pb-24 md:pb-0 bg-plum-deep" data-id="element-19" data-mp="nvj4pj9gikrb">
        <Footer data-id="element-20" data-mp="nur948fv0n11" />
      </div>
      <PurchaseNotifications data-id="element-21" data-mp="nxn4bp0boxls" />
      <MobileBuyBar data-id="element-22" data-mp="sudlkfnv5z8s" />
    </div>;
}